import WutBadge_StylableBadgeComponent from '../components/WutBadge/viewer/skinComps/Stylable/StylableBadge.skin';
import WutBadge_StylableBadgeController from '../.components/WutBadge/viewer/WutBadge.controller';


const WutBadge_StylableBadge = {
  component: WutBadge_StylableBadgeComponent,
  controller: WutBadge_StylableBadgeController
};


export const components = {
  ['WutBadge_StylableBadge']: WutBadge_StylableBadge
};

